import styled from 'styled-components'

import { WhiteBlock } from 'components/Layout'

export const MobileTableBlock = styled(WhiteBlock)`
  width: 100%;
  gap: 16px;
  padding: 16px;
`

export const MobileTableBlockHeader = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
`

export const MobileTableBlockRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const MobileTableBlockCell = styled.div`
  display: flex;
  min-width: 30%;
  :last-child {
    justify-content: flex-end;
  }
`
